import { Components, customHooks } from "@thisgorilla/primate-ds";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { ROUTES } from "../../../../../../../../utills/routes";
import {
  FlexColumn,
  FlexRowCenter,
  FlexRowSpaced,
} from "../../../../../../../Common/Styles";
import { DraftsModalProps } from "../../DraftsModal";
import { API_CALLS } from "../../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../../redux";

const DraftItem = ({
  date,
  title,
  post_id,
  selectedTabIndex,
  setDeliveryDate,
  setSchedulePostOpen,
  setSchedulePostId,
}: DraftsModalProps.DraftItemProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { typography, Color } = useTheme();
  const navigate = useNavigate();
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const { draftArticle } = useAppSelector((state) => state.article);

  customHooks.useClickOutside({ ref, setState: setIsDropDownOpen });

  const formatedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const formatedTime =
    " @ " +
    date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/\s?(AM|PM)/, (_, p1) => p1.toLowerCase());

  const color = [
    Color.text["text-tertiary"].value,
    Color.text["text-emphasize-brand"].value,
    Color.text["text-emphasize-positive"].value,
  ];

  const description = [
    "Last modified on " + formatedDate + formatedTime,
    "Scheduled for " + formatedDate + formatedTime,
    "Published  on " + formatedDate + formatedTime,
  ];

  return (
    <>
      <DraftItemContainer>
        <HeadingContainer>
          <Components.Text
            style={{ tokenStyle: typography.Body.M }}
            text={description[selectedTabIndex]}
            color={color[selectedTabIndex]}
          />
          <FlexRowCenter>
            {selectedTabIndex > 0 && (
              <Components.StatusIndicator iconType="Check" state="Positive" />
            )}
            <IconButtonWrapper $isOpen={isDropDownOpen} ref={ref}>
              <Components.IconButton
                disabled={false}
                iconType="MoreHorizontal"
                kind="Tertiary"
                size="Small"
                onClick={() => setIsDropDownOpen(!isDropDownOpen)}
              />
              {isDropDownOpen && (
                <DropDownContainer>
                  <Components.Menu size="large" itemGap={0} withBackground>
                    {selectedTabIndex < 2 && (
                      <>
                        <Components.ListItem
                          type="List Item"
                          label="Edit"
                          onClick={() =>
                            navigate(ROUTES.article + `?article_id=${post_id}`)
                          }
                          iconType="Edit"
                        />
                        <Components.ListItem
                          type="List Item"
                          label={selectedTabIndex ? "Reschedule" : "Schedule"}
                          onClick={() => {
                            selectedTabIndex && setDeliveryDate(String(date));
                            setSchedulePostId(post_id);
                            setSchedulePostOpen(true);
                          }}
                          iconType="Calendar"
                        />
                      </>
                    )}
                    <Components.ListItem
                      type="List Item"
                      label="Remove"
                      onClick={() => {
                        API_CALLS.ARTICLE.deleteArticleDraft(post_id).then(
                          () => {
                            post_id === draftArticle.post_id &&
                              (window.location.href = ROUTES.article);
                            setIsDropDownOpen(false);
                          }
                        );
                      }}
                      iconType="Trash2"
                    />
                  </Components.Menu>
                </DropDownContainer>
              )}
            </IconButtonWrapper>
          </FlexRowCenter>
        </HeadingContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.S }}
          text={title ? title : "Untitled"}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-400"
          maxLineLength={2}
        />
      </DraftItemContainer>
    </>
  );
};

export default DraftItem;

const DraftItemContainer = styled(FlexColumn)`
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

const HeadingContainer = styled(FlexRowSpaced)`
  align-items: center;
`;

const IconButtonWrapper = styled.div<{ $isOpen: boolean }>`
  position: relative;

  button {
    background: ${({ $isOpen, theme }) =>
      $isOpen &&
      theme.Color.background.brand.subtlest["default-active"].value}!important;
  }
`;
const DropDownContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-9"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-none"].value}rem;
`;
